<template>
  <div
    v-show="visible" style="display: none"
    class="tw-fixed tw-bottom-0 tw-left-0 tw-w-full tw-bg-dark-1 tw-text-light tw-z-infinite"
  >
    <div class="container tw-mx-auto tw-py-10 tw-flex tw-items-center tw-justify-between">
      <div class="tw-font-light tw-text-2xl">This website uses cookies in order to offer you the most relevant information. Please accept cookies for optimal performance.</div>
      <div class="tw-flex tw-items-center tw-space-x-5">
        <button v-on:click="confirm" class="tw-px-5 tw-py-2 tw-bg-primary tw-text-light tw-font-bold tw-outline-none">Accept And Close</button>
        <button class="tw-px-5 tw-py-2 tw-bg-light tw-bg-opacity-25 tw-text-light tw-font-bold tw-outline-none">Read More</button>
      </div>
    </div>
  </div>
</template>
<script>
  import Cookies from 'js-cookie'
  export default {
    data : v => ({
      visible : Cookies.get('cookie-contest') !== 'accepted',
    }),
    methods : {
      confirm(){
        Cookies.set('cookie-contest', 'accepted')
        this.visible = false
      }
    }
  }
</script>
